module.exports = {
	"absenteeBids": "Pré-offres",
	"biddingNotPossible": "La soumission d'offres n'est pas possible pour cet encan.",
	"header": "Tableau de bord",
	"maximumUpTo": "Vous avez soumis un maximum jusqu'à: __maximum__",
	"noAbsenteeBids": "Vous n'avez soumis aucune offre.",
	"noBids": "Vous n'avez soumis aucune enchère.",
	"noInformationOnAuction": "Aucune information à propos de l'état de cet encan n'est disponible.",
	"noMaximumBid": "Vous n'avez pas soumis d'offre maximale.",
	"notWatchingAnyAuction": "Vous ne suivez aucun encan.",
	"notWatchingAnyLots": "Vous ne suivez aucun lot.",
	"silentBid": "C'est un encan silencieux.",
	"watchedAuctions": "Encans suivis",
	"watchedLots": "Lots suivis",
	"bids": "Enchères",
	"wonLot": "Vous avez gagné ce lot.",
	"lostLot": "Vous avez perdu ce lot.",
	"cancelledLot": "Ce lot a été annulé."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/dashboard.json5
// module id = 1978
// module chunks = 6